export default "__VITE_ASSET__0WuIrx6M__"